import React from 'react';
import { WorkflowDocumentPicker } from 'src/app/workflows/WorkflowDocumentPicker';
import { ResourceAttachmentDto } from 'src/api/FiretrolApiClient';
import { useRfiDocumentOptions } from 'src/api/queries/rfis/useRfiQueries';
import { useAttachRfiDocument } from 'src/api/queries/rfis/useRfiMutations';

export interface IRFIDocumentPickerProps {
  jobId: number;
  onAttached: (attachment: ResourceAttachmentDto) => void;
}

export const RFIDocumentPicker: React.FC<IRFIDocumentPickerProps> = ({
  jobId,
  onAttached,
}) => {
  const { data } = useRfiDocumentOptions(jobId);
  const attach = useAttachRfiDocument();

  return (
    <WorkflowDocumentPicker
      jobId={jobId}
      onAttached={onAttached}
      options={data ?? []}
      attachFromDocument={(id, documentId) =>
        attach.mutateAsync({ jobId: id, documentId })
      }
      attaching={attach.isPending}
    />
  );
};
